import gql from 'graphql-tag'

export const getFeedbackQuestionQuery = gql`
  query DooerComGetFeedbackQuestion($id: ID!) {
    feedbackQuestion(id: $id) {
      id
      description
      labelGood
      labelBad
      createdAt
    }
  }
`

export const createFeedbackResultMutation = gql`
  mutation DooerComCreateFeedbackResult($input: FeedbackResultInput!) {
    feedbackResults {
      create(input: $input) {
        id
      }
    }
  }
`
